import { buildMeta } from "../routeMeta";

export { default } from "../../src/pages/trade-data-methodology/FullWidthPage";

export function meta(args) {
  return buildMeta(
    {
      title: "Trade Data Methodology — The Atlas of Economic Complexity",
      description:
        "How the Atlas builds its trade dataset: sources, cleaning, and reconciliation methodology.",
    },
    args,
  );
}
